import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
export var useQuoteGABusinessInsuranceFieldDisplay = function useQuoteGABusinessInsuranceFieldDisplay() {
  var _ref = useFormContext() || {},
      watch = _ref.watch;

  var _useState = useState(false),
      isFastTrack = _useState[0],
      setIsFastTrack = _useState[1];

  var _useState2 = useState(false),
      showWorkRequireCertifiedPercentage = _useState2[0],
      setShowWorkRequireCertifiedPercentage = _useState2[1];

  var _useState3 = useState(false),
      showSubcontractorPercentage = _useState3[0],
      setShowSubcontractorPercentage = _useState3[1];

  var _useState4 = useState(false),
      showTotalCostClaims = _useState4[0],
      setShowTotalCostClaims = _useState4[1];
  /**
   * watch
   */


  var flowModeWatch = watch('flowMode');
  var declarationQuestionsWatch = watch('declarationQuestions');
  /**
   * effects
   */

  useEffect(function () {
    var _declarationQuestions, _declarationQuestions2, _declarationQuestions3, _declarationQuestions4;

    var isFast = (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions = declarationQuestionsWatch['greate_american_us_quick_journey_criteria']) === null || _declarationQuestions === void 0 ? void 0 : _declarationQuestions.truelyValue) === true;
    setIsFastTrack(isFast);
    setShowWorkRequireCertifiedPercentage(!isFast && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions2 = declarationQuestionsWatch.greate_american_us_work_require_certified) === null || _declarationQuestions2 === void 0 ? void 0 : _declarationQuestions2.truelyValue) === true);
    setShowSubcontractorPercentage(!isFast && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions3 = declarationQuestionsWatch.greate_american_us_conducted_by_subcontractors) === null || _declarationQuestions3 === void 0 ? void 0 : _declarationQuestions3.truelyValue) === true);
    setShowTotalCostClaims(!isFast && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions4 = declarationQuestionsWatch.greate_american_us_past_professional_liability_claims) === null || _declarationQuestions4 === void 0 ? void 0 : _declarationQuestions4.truelyValue) === true);
  }, [flowModeWatch, declarationQuestionsWatch]);
  return {
    isFastTrack: isFastTrack,
    showWorkRequireCertifiedPercentage: showWorkRequireCertifiedPercentage,
    showSubcontractorPercentage: showSubcontractorPercentage,
    showTotalCostClaims: showTotalCostClaims
  };
};